export type WorksheetStatus = "DRAFT_IN_PROGRESS" | "PENDING_APPROVAL" | "ACTIVE" | "INACTIVE"

export interface MultiAllocationSheetData {
    sheetId: string;
    sheetName: string;
    sheetVersion: number;
    segmentType: string;
    description: string;
    lastUpdatedBy: string;
    lastUpdatedAt: string; // Formatted date string (transformed from Unix epoch)
    status: WorksheetStatus;
    createdAt: string, // Formatted date string (transformed from Unix epoch)
    createdBy: string
}

/**
 * Response structure for the sheets list API
 */
export interface ListMultiAllocationSheetsResponse {
    sheets: MultiAllocationSheetData[];
}

export enum MDA_SEGMENTS {
    COST_CENTER = "COST_CENTER",
    LOCATION = "LOCATION",
    PRODUCT_LINE = "PRODUCT_LINE",
    CHANNEL = "CHANNEL",
    PROJECT = "PROJECT",
    LG_CODE = "LG_CODE"
}
